import * as React from 'react';
import { VtxColumnProps } from '@vertexinc/vtx-ui-react-component-library';
import {
  booleanCompare,
  FilterDropdownProps,
  searchOrSelectFilter,
  SearchFilter,
  stringCompare,
} from '@vcd-ecm-ui/GenericGrid';
import GridRowData from './GridRowData';

const columns: VtxColumnProps<GridRowData>[] = [
  {
    title: 'Name',
    dataIndex: 'name',
    sorter: (a: GridRowData, b: GridRowData) => stringCompare(a.rowData.name, b.rowData.name),
    ellipsis: true,
    className: 'correspondenceColumnStyle',
    render: (value, row: GridRowData, index: number) => (value || 'No Contact Name provided'),
    // eslint-disable-next-line max-len
    // filterDropdown: (props: FilterDropdownProps) => <SearchFilter filterType={SearchFilterTypeEnum.Text} title="Name" dataIndex="name" props={props} />,
    // Client Side Filter
    // onFilter: (value: string | number | boolean, record: GridRowData) => searchOrSelectFilter(value as string, record),
  },
  {
    title: 'E-Mail',
    dataIndex: 'email',
    sorter: (a: GridRowData, b: GridRowData) => stringCompare(a.rowData.email, b.rowData.email),
    ellipsis: true,
    className: 'correspondenceColumnStyle',
  },
  {
    title: 'Status',
    dataIndex: 'subscribed',
    sorter: (a: GridRowData, b: GridRowData) => booleanCompare(a.rowData.emailSubscribedInd, b.rowData.emailSubscribedInd),
    width: 160,
  },
];

const getDefaultColumns = (): VtxColumnProps<GridRowData>[] => columns;

export default getDefaultColumns;
